"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOpacityRelatedStyles = void 0;
const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000,
        cursor: "default",
        backgroundColor: "#6b7280bf",
        transitionProperty: "opacity",
        transitionTimingFunction: "ease-in",
        transitionDuration: ".15s",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "1rem",
    },
    root: {
        cursor: "default",
        backgroundColor: "#fff",
        borderRadius: "0.5rem",
        overflow: "hidden",
        position: "relative",
        padding: "1.25rem",
        paddingBottom: "2.5em",
        transitionProperty: "all",
        transitionTimingFunction: "ease-in",
        transitionDuration: ".15s",
        maxWidth: "600px",
        "@media only screen and (min-width: 598px)": {
            width: "600px",
        },
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "1rem",
    },
    closeIcon: {
        height: "20px",
        width: "20px",
        color: "#98A2B3",
    },
    title: {
        fontSize: "18px",
        fontWeight: 600,
    },
};
function getOpacityRelatedStyles(opacity) {
    const isEntering = opacity === 1;
    return {
        overlay: {
            opacity,
        },
        root: {
            opacity,
            scale: isEntering ? 1 : 0.7,
            transitionDelay: isEntering ? "0.05s" : "0s",
        },
    };
}
exports.getOpacityRelatedStyles = getOpacityRelatedStyles;
exports.default = styles;
//# sourceMappingURL=styles.js.map